(function() {
  'use strict';

  function initVariantSelectors() {
    document.removeEventListener('click', handleVariantClick);
    document.addEventListener('click', handleVariantClick);
  }

  function handleVariantClick(e) {
    const colorSwatch = e.target.closest('.color-swatch');
    if (colorSwatch) {
      handleColorSwatchClick(colorSwatch, e);
      return;
    }

    const variantCard = e.target.closest('.variant-card');
    if (variantCard) {
      handleVariantCardClick(variantCard, e);
      return;
    }
  }

  function handleColorSwatchClick(swatch, e) {
    e.preventDefault();

    const selectedValue = swatch.dataset.value;
    const optionContainer = swatch.closest('.product-option-color');
    const optionName = optionContainer.dataset.optionName;

    const allSwatches = optionContainer.querySelectorAll('.color-swatch');
    allSwatches.forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');

    const valueText = optionContainer.querySelector('.option-value-text');
    if (valueText) {
      valueText.textContent = selectedValue;
    }

    updateNativeVariantSelector(optionName, selectedValue);

    setTimeout(() => {
      filterVariantCards();
    }, 20);
  }

  function handleVariantCardClick(card, e) {
    e.preventDefault();

    const optionValue = card.dataset.optionValue;
    const container = card.closest('.variant-cards');
    const optionName = container.dataset.optionName;

    const allCards = container.querySelectorAll('.variant-card');
    allCards.forEach(c => c.classList.remove('active'));
    card.classList.add('active');

    updateNativeVariantSelector(optionName, optionValue);
  }

  function updateNativeVariantSelector(optionName, optionValue) {
    const variantSelectsEl = document.querySelector('variant-selects:not([data-sticky])');
    if (!variantSelectsEl) return;

    const optionHandle = optionName.toLowerCase().replace(/\s+/g, '-');
    const targetFieldset = variantSelectsEl.querySelector(`fieldset.hidden-native-selector[data-handle="${optionHandle}"]`);

    if (!targetFieldset) return;

    const radioInputs = targetFieldset.querySelectorAll('input[type="radio"]');
    let changed = false;

    radioInputs.forEach(radio => {
      if (radio.value === optionValue) {
        if (!radio.checked) {
          radio.checked = true;
          changed = true;
        }
      }
    });

    if (changed) {
      const changeEvent = new Event('change', {
        bubbles: true,
        cancelable: true
      });
      targetFieldset.dispatchEvent(changeEvent);
    }
  }

  function getCurrentOptionSelections() {
    const variantSelectsEl = document.querySelector('variant-selects:not([data-sticky])');
    if (!variantSelectsEl) return {};

    const selections = {};
    const allFieldsets = variantSelectsEl.querySelectorAll('fieldset[data-index]');

    allFieldsets.forEach(fieldset => {
      const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        const optionName = checkedRadio.name.replace('--sticky', '');
        selections[optionName] = checkedRadio.value;
      }
    });

    return selections;
  }

  function filterVariantCards() {
    const currentSelections = getCurrentOptionSelections();

    document.querySelectorAll('.variant-cards').forEach(container => {
      const optionName = container.dataset.optionName;
      const allCards = container.querySelectorAll('.variant-card');

      allCards.forEach(card => {
        const cardOption1 = card.dataset.option1;
        const cardOption2 = card.dataset.option2;
        const cardOption3 = card.dataset.option3;

        let shouldShow = true;

        for (const [selectedOptionName, selectedValue] of Object.entries(currentSelections)) {
          if (selectedOptionName === optionName) {
            continue;
          }

          let cardValue = null;

          const variantSelectsEl = document.querySelector('variant-selects:not([data-sticky])');
          const allFieldsets = Array.from(variantSelectsEl.querySelectorAll('fieldset[data-index]'));

          allFieldsets.forEach((fieldset, index) => {
            const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
            if (checkedRadio && checkedRadio.name === selectedOptionName) {
              if (index === 0) cardValue = cardOption1;
              else if (index === 1) cardValue = cardOption2;
              else if (index === 2) cardValue = cardOption3;
            }
          });

          if (cardValue && cardValue !== selectedValue) {
            shouldShow = false;
            break;
          }
        }

        if (shouldShow) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
          if (card.classList.contains('active')) {
            card.classList.remove('active');
          }
        }
      });

      const visibleCards = Array.from(allCards).filter(c => c.style.display !== 'none');
      const hasActiveCard = visibleCards.some(c => c.classList.contains('active'));

      if (visibleCards.length > 0 && !hasActiveCard) {
        visibleCards[0].classList.add('active');
        const firstCardValue = visibleCards[0].dataset.optionValue;
        updateNativeVariantSelector(optionName, firstCardValue);
      }
    });
  }

  function listenToAllOptionChanges() {
    const variantSelectsEl = document.querySelector('variant-selects:not([data-sticky])');
    if (!variantSelectsEl) return;

    variantSelectsEl.addEventListener('change', function(e) {
      setTimeout(() => {
        filterVariantCards();
      }, 10);
    });
  }

  function listenToThemeVariantChanges() {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    variantInput.addEventListener('change', function() {
      const selectedVariantId = this.value;

      // 更新 color swatches - 基于当前选中的选项值而非 variant ID
      syncColorSwatchesWithCurrentSelection();

      // 更新 variant cards
      document.querySelectorAll('.variant-card').forEach(card => {
        if (card.dataset.variantId === selectedVariantId) {
          card.classList.add('active');
        } else {
          card.classList.remove('active');
        }
      });
    });
  }

  function syncColorSwatchesWithCurrentSelection() {
    const currentSelections = getCurrentOptionSelections();

    document.querySelectorAll('.product-option-color').forEach(container => {
      const optionName = container.dataset.optionName;
      const selectedValue = currentSelections[optionName];

      if (!selectedValue) return;

      const allSwatches = container.querySelectorAll('.color-swatch');
      const valueText = container.querySelector('.option-value-text');

      allSwatches.forEach(swatch => {
        if (swatch.dataset.value === selectedValue) {
          swatch.classList.add('active');
          if (valueText) {
            valueText.textContent = selectedValue;
          }
        } else {
          swatch.classList.remove('active');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initVariantSelectors();
    listenToAllOptionChanges();
    listenToThemeVariantChanges();
    setTimeout(() => {
      filterVariantCards();
    }, 100);
  }

})();
